(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const counters = document.querySelectorAll('[data-count-up]');
    if (!counters.length) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const animate = (el) => {
      const target = parseInt(el.dataset.target, 10);
      const suffix = el.dataset.suffix || '';

      if (prefersReducedMotion) {
        el.textContent = target + suffix;
        return;
      }

      const duration = 1200;
      const start = performance.now();

      const step = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.round(eased * target) + suffix;

        if (progress < 1) {
          requestAnimationFrame(step);
        }
      };

      requestAnimationFrame(step);
    };

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animate(entry.target);
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );

    counters.forEach((counter) => observer.observe(counter));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  /* Builds the `cart:add` detail from a product form's FormData. It lives here
     because the drawer is the one component rendered on every page, and every
     add-to-cart in the theme calls it. The linked-item rule rides along as
     hidden inputs (see `snippets/linked-product-inputs.liquid`) so the drawer
     can add the trigger and its linked product in a single request. */
  window.cartAddDetail = function (formData, button) {
    const detail = {
      id: formData.get('id'),
      quantity: Number(formData.get('quantity')) || 1,
      button: button || null,
    };

    const linkedId = formData.get('_linked_variant_id');

    if (linkedId) {
      detail.linked = { id: linkedId, ratio: Number(formData.get('_linked_ratio')) || 1 };
    }

    return detail;
  };

  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.body = this.querySelector('[data-cart-drawer-body]');
      this.errorElement = this.querySelector('[data-cart-drawer-error]');
      this.cartUrl = this.dataset.cartUrl;
      this.itemCount = Number(this.body.dataset.itemCount || 0);
      this.pendingQuantities = new Map();
      this.quantityTimers = new Map();

      /* Line keys with a mutation in flight, so a body swap mid-request can
         reapply their loading state instead of it flashing off and back on. */
      this.pendingRequests = new Set();

      /* Rules whose linked product could not be added - sold out, or deleted
         since the metafield was set. Without a latch, every later render would
         retry the same doomed request for the rest of the visit. */
      this.failedRules = new Set();

      /* The cart is one shared resource and concurrent writes to it silently
         lose updates, so every mutation queues behind the last one. */
      this.chain = Promise.resolve();

      this.termsStorageKey = 'cart-drawer-terms-accepted';
      this.termsAccepted = window.sessionStorage.getItem(this.termsStorageKey) === 'true';

      /* A theme-editor re-render would otherwise leave the previous element
         subscribed to `cart:add`, turning one add into two. */
      this.controller = new AbortController();
      const signal = this.controller.signal;

      this.querySelector('[data-cart-drawer-close]').addEventListener('click', () => this.close(), { signal });

      this.dialog.addEventListener(
        'click',
        (event) => {
          if (event.target === this.dialog) this.close();
        },
        { signal }
      );

      this.dialog.addEventListener(
        'cancel',
        (event) => {
          event.preventDefault();
          this.close();
        },
        { signal }
      );

      this.bindBody();
      this.updateCheckoutState();

      document.addEventListener('cart:open', () => this.open(), { signal });
      document.addEventListener(
        'cart:add',
        (event) => {
          const button = event.detail && event.detail.button;
          this.setButtonLoading(button, true);
          this.addItem(event.detail).finally(() => this.setButtonLoading(button, false));
        },
        { signal }
      );

      /* The cart can arrive already out of sync: edited on /cart, changed in
         another tab, or filled before its rule was. The markup is fresh from
         the server, so diff it directly - a consistent cart costs no request. */
      this.enqueue(async () => {
        const plan = this.plan();
        if (plan.adds.length === 0 && plan.changes.length === 0) return;
        await this.settle(await this.apply(plan));
      });
    }

    disconnectedCallback() {
      this.controller.abort();
      this.quantityTimers.forEach((timer) => clearTimeout(timer));
      this.quantityTimers.clear();
      this.pendingQuantities.clear();
      this.pendingRequests.clear();
      clearTimeout(this.errorTimer);
    }

    /* Serializes every cart write. Errors are swallowed here so one failure
       can't wedge the queue for everything behind it. */
    enqueue(task) {
      this.chain = this.chain
        .then(() => task())
        .catch((error) => {
          console.error(error);
        });

      return this.chain;
    }

    async request(endpoint, payload) {
      const response = await fetch(window.Shopify.routes.root + endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(data.description || data.message || 'Unable to update the cart');
      }

      return data;
    }

    bindBody() {
      this.body.addEventListener('click', (event) => this.handleBodyClick(event));
      this.body.addEventListener('change', (event) => this.handleBodyChange(event));
    }

    handleBodyChange(event) {
      if (event.target.matches('[data-cart-drawer-terms]')) {
        this.termsAccepted = event.target.checked;
        window.sessionStorage.setItem(this.termsStorageKey, String(this.termsAccepted));
        this.updateCheckoutState();
      }
    }

    /* Toggled on the button that triggered a `cart:add`, for the whole request
       (including the linked-item retry-fallback, since both live in the same
       `addItem` call). */
    setButtonLoading(button, isLoading) {
      if (!button) return;
      button.disabled = isLoading;
      button.toggleAttribute('data-loading', isLoading);
      button.setAttribute('aria-busy', String(isLoading));
    }

    /* Locks one line's own controls while its mutation is in flight. Other
       lines stay interactive - the mutex already keeps concurrent edits to
       different lines correct, so there's no reason to make them feel stuck.

       These pulse rather than taking a spinner: they're too small for one to
       sit over without covering the label it's replacing. */
    setLineLoading(item, isLoading) {
      if (!item) return;
      item.querySelectorAll('.cart-drawer__quantity-button, .cart-drawer__item-remove').forEach((element) => {
        element.disabled = isLoading;
        element.toggleAttribute('data-loading-pulse', isLoading);
        element.setAttribute('aria-busy', String(isLoading));
      });
    }

    /* A body swap replaces the line wholesale, wiping any loading state a
       still-in-flight request had set on the old DOM - reapply it, same idea
       as restorePendingQuantities(). */
    restoreLoadingLines() {
      this.pendingRequests.forEach((key) => {
        this.setLineLoading(this.body.querySelector(`[data-key="${key}"]`), true);
      });
    }

    updateCheckoutState() {
      const checkbox = this.body.querySelector('[data-cart-drawer-terms]');
      const checkout = this.body.querySelector('[data-cart-drawer-checkout]');

      if (checkbox) checkbox.checked = this.termsAccepted;
      if (!checkout) return;

      /* A quantity change that's debounced or still in flight hasn't landed in
         the cart yet - checkout shouldn't be reachable with a stale total. */
      const enabled =
        this.itemCount > 0 && this.termsAccepted && this.pendingRequests.size === 0 && this.quantityTimers.size === 0;
      checkout.classList.toggle('is-disabled', !enabled);

      if (enabled) {
        checkout.removeAttribute('aria-disabled');
        checkout.removeAttribute('tabindex');
      } else {
        checkout.setAttribute('aria-disabled', 'true');
        checkout.setAttribute('tabindex', '-1');
      }
    }

    open() {
      if (!this.dialog.open) this.dialog.showModal();
      requestAnimationFrame(() => this.dialog.classList.add('is-open'));
    }

    close() {
      this.dialog.classList.remove('is-open');
      setTimeout(() => {
        if (this.dialog.open) this.dialog.close();
      }, 300);
    }

    /* `detail` is `{ id, quantity }`, optionally with `linked: { id, ratio }`
       resolved from the trigger product's metafields at the buy button. Sending
       both in one request is what lets the drawer open already correct instead
       of adding the linked item in a visible second step. */
    addItem(detail) {
      return this.enqueue(async () => {
        const items = [{ id: detail.id, quantity: detail.quantity }];

        if (detail.linked) {
          items.push({
            id: detail.linked.id,
            quantity: detail.quantity * (detail.linked.ratio || 1),
            properties: { _linked_to: String(detail.id) },
          });
        }

        let data;

        try {
          data = await this.request('cart/add.js', { items, sections: 'cart-drawer' });
        } catch (error) {
          /* /cart/add.js is all-or-nothing, so a sold-out linked product would
             otherwise take the product the customer actually asked for down
             with it. Retry without it and say what happened. */
          if (items.length === 1) {
            this.reportAddFailure(error);
            return;
          }

          this.failedRules.add(items[1].properties._linked_to + ':' + items[1].id);

          try {
            data = await this.request('cart/add.js', { items: [items[0]], sections: 'cart-drawer' });
            this.showError(this.dataset.linkedUnavailableText || error.message);
          } catch (retryError) {
            this.reportAddFailure(retryError);
            return;
          }
        }

        await this.settle(data.sections && data.sections['cart-drawer']);
        this.open();
      });
    }

    /* The drawer stays closed when an add fails, so the error also has to reach
       whoever asked for it - the product page shows it inline. */
    reportAddFailure(error) {
      document.dispatchEvent(new CustomEvent('cart:error', { detail: { message: error.message } }));
      this.showError(error.message);
      console.error(error);
    }

    changeItem(key, quantity) {
      return this.enqueue(async () => {
        this.pendingRequests.add(key);
        this.updateCheckoutState();

        try {
          const data = await this.request('cart/change.js', { id: key, quantity, sections: 'cart-drawer' });
          await this.settle(data.sections && data.sections['cart-drawer']);
        } catch (error) {
          this.showError(error.message);
          console.error(error);
          await this.settle();
        } finally {
          /* settle() re-renders while this key is still pending, so the fresh
             line comes back with its loading state reapplied - dropping the
             key alone would leave it stuck on screen forever. */
          this.pendingRequests.delete(key);
          this.setLineLoading(this.body.querySelector(`[data-key="${key}"]`), false);
          this.updateCheckoutState();
        }
      });
    }

    showError(message) {
      if (!this.errorElement || !message) return;
      this.errorElement.textContent = message;
      this.errorElement.hidden = false;
      clearTimeout(this.errorTimer);
      this.errorTimer = setTimeout(() => {
        this.errorElement.hidden = true;
      }, 4000);
    }

    /* Swaps in fresh markup and nothing else - no mutation, no event. `html` is
       the section markup returned alongside a mutation; only a failed mutation
       has to go and fetch it. */
    async render(html) {
      try {
        if (!html) {
          const response = await fetch(`${this.cartUrl}?sections=cart-drawer`);
          const data = await response.json();
          html = data['cart-drawer'];
        }

        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const newBody = parsed.querySelector('[data-cart-drawer-body]');
        const newCount = parsed.querySelector('[data-cart-drawer-count]');

        if (!newBody) return;

        this.itemCount = Number(newBody.dataset.itemCount || 0);
        this.body.replaceWith(newBody);
        this.body = newBody;
        this.bindBody();
        this.restorePendingQuantities();
        this.restoreLoadingLines();
        this.updateCheckoutState();

        if (newCount) {
          this.querySelector('[data-cart-drawer-count]').textContent = newCount.textContent;
        }

        this.updateCartCount();
      } catch (error) {
        /* Stale-but-valid markup beats reporting a failure for a mutation that
           actually went through. */
        console.error(error);
      }
    }

    /* The body swap wipes the optimistic quantity a debounced click put on
       screen, which would make the number snap back and then jump forward again
       400ms later. */
    restorePendingQuantities() {
      this.pendingQuantities.forEach((quantity, key) => {
        const line = this.body.querySelector(`[data-key="${key}"]`);

        if (!line) {
          clearTimeout(this.quantityTimers.get(key));
          this.quantityTimers.delete(key);
          this.pendingQuantities.delete(key);
          return;
        }

        const value = line.querySelector('.cart-drawer__quantity-value');
        if (value) value.textContent = quantity;
      });
    }

    /* Diffs the linked items the rendered cart should hold against the ones it
       does. Pure: reads the DOM, touches nothing. */
    plan() {
      const empty = { adds: [], changes: [] };

      /* A debounced quantity change hasn't been committed yet, so the numbers on
         screen are optimistic. Reconciling against them would add the linked
         item at the wrong quantity and immediately correct it, in full view.
         The debounce ends in changeItem, which settles again. */
      if (this.quantityTimers.size > 0) return empty;

      const desired = new Map();
      const actual = new Map();

      this.body.querySelectorAll('[data-cart-drawer-line-item]').forEach((line) => {
        const quantity = Number(line.dataset.quantity || 0);

        /* Belt and braces: the Liquid already refuses to give a linked line a
           rule of its own. */
        if (line.dataset.linkedTo) {
          const rows = actual.get(line.dataset.linkedTo) || [];
          rows.push({ key: line.dataset.key, variantId: line.dataset.variantId, quantity: quantity });
          actual.set(line.dataset.linkedTo, rows);
          return;
        }

        const linkedVariantId = line.dataset.linkedVariantId;
        if (!linkedVariantId) return;
        if (this.failedRules.has(line.dataset.variantId + ':' + linkedVariantId)) return;

        desired.set(line.dataset.variantId, {
          variantId: linkedVariantId,
          quantity: quantity * (Number(line.dataset.linkedRatio) || 1),
        });
      });

      const adds = [];
      const changes = [];

      desired.forEach((want, owner) => {
        const rows = actual.get(owner) || [];
        const match = rows.find((row) => row.variantId === want.variantId);

        /* Anything else owned by this trigger is a rule that has since been
           pointed at a different product. */
        rows.forEach((row) => {
          if (row !== match) changes.push({ key: row.key, quantity: 0 });
        });

        if (!match) {
          adds.push({ id: want.variantId, quantity: want.quantity, properties: { _linked_to: owner } });
        } else if (match.quantity !== want.quantity) {
          changes.push({ key: match.key, quantity: want.quantity });
        }
      });

      /* No owner left. Covers the trigger being removed, its rule being
         cleared, and the rule being latched as failed - one branch each. */
      actual.forEach((rows, owner) => {
        if (desired.has(owner)) return;
        rows.forEach((row) => changes.push({ key: row.key, quantity: 0 }));
      });

      return { adds: adds, changes: changes };
    }

    async apply(plan) {
      let html = null;
      const lastIsChange = plan.changes.length > 0;

      if (plan.adds.length > 0) {
        try {
          const data = await this.request('cart/add.js', {
            items: plan.adds,
            sections: lastIsChange ? undefined : 'cart-drawer',
          });

          if (!lastIsChange) html = data.sections && data.sections['cart-drawer'];
        } catch (error) {
          /* The request is all-or-nothing, so there's no telling which linked
             product failed - latch the whole batch. */
          plan.adds.forEach((add) => this.failedRules.add(add.properties._linked_to + ':' + add.id));
          this.showError(this.dataset.linkedUnavailableText || error.message);
          console.error(error);
        }
      }

      /* Sequential on purpose: concurrent writes to the same cart lose updates. */
      for (let index = 0; index < plan.changes.length; index += 1) {
        const change = plan.changes[index];
        const isLast = index === plan.changes.length - 1;

        try {
          const data = await this.request('cart/change.js', {
            id: change.key,
            quantity: change.quantity,
            sections: isLast ? 'cart-drawer' : undefined,
          });

          if (isLast) html = data.sections && data.sections['cart-drawer'];
        } catch (error) {
          /* The line is already gone, which is the state we were after. */
          console.error(error);
        }
      }

      return html;
    }

    /* Renders, diffs, mutates, repeats - then announces the settled cart once.
       Two passes is the whole budget: the first applies the plan, the second
       confirms it took. A third would only ever mean a mutation failed, and
       that case belongs to the failure latch, not to more retries. */
    async settle(html) {
      for (let pass = 0; pass < 2; pass += 1) {
        await this.render(html);
        html = null;

        const plan = this.plan();
        if (plan.adds.length === 0 && plan.changes.length === 0) break;

        html = await this.apply(plan);
      }

      if (html) await this.render(html);

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { itemCount: this.itemCount } }));
    }

    updateCartCount() {
      document.querySelectorAll('[data-cart-count]').forEach((element) => {
        element.textContent = this.itemCount;
        element.hidden = this.itemCount === 0;
      });
    }

    handleBodyClick(event) {
      const item = event.target.closest('[data-cart-drawer-line-item]');
      if (!item) return;

      /* A linked line has neither control rendered, but its quantity is owned
         by its trigger either way. */
      if (item.dataset.linkedTo) return;

      const key = item.dataset.key;

      if (event.target.closest('[data-cart-drawer-remove]')) {
        this.pendingQuantities.delete(key);
        clearTimeout(this.quantityTimers.get(key));
        this.setLineLoading(item, true);
        this.changeItem(key, 0);
        return;
      }

      const quantityElement = item.querySelector('.cart-drawer__quantity-value');
      if (!quantityElement) return;

      const isIncrease = event.target.closest('[data-cart-drawer-quantity-increase]');
      const isDecrease = event.target.closest('[data-cart-drawer-quantity-decrease]');
      if (!isIncrease && !isDecrease) return;

      // Reads from the pending map (not the DOM) so rapid clicks accumulate
      // correctly instead of each one racing off the same stale on-screen
      // number while a previous change.js request is still in flight.
      const current = this.pendingQuantities.has(key)
        ? this.pendingQuantities.get(key)
        : Number(quantityElement.textContent);
      const quantity = Math.max(current + (isIncrease ? 1 : -1), 0);

      this.pendingQuantities.set(key, quantity);
      quantityElement.textContent = quantity;

      clearTimeout(this.quantityTimers.get(key));
      this.quantityTimers.set(
        key,
        setTimeout(() => {
          this.pendingQuantities.delete(key);
          this.quantityTimers.delete(key);
          const freshItem = this.body.querySelector(`[data-key="${key}"]`);
          this.setLineLoading(freshItem, true);
          this.changeItem(key, quantity);
        }, 400)
      );

      /* Checkout should disable the instant a change is pending, not only once
         the debounce fires and the request actually starts. */
      this.updateCheckoutState();
    }
  }

  customElements.define('cart-drawer', CartDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  /* Turns the plain quantity inputs into steppers and takes over submitting, so
     a change applies without the customer hunting for the Update button. With
     JavaScript off, the inputs and that button still work on their own. */
  class CartLines extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');

      if (!this.form) return;

      this.querySelectorAll('[data-cart-update]').forEach((button) => {
        button.hidden = true;
      });

      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-quantity-step]');

        if (!button) return;

        const input = button.parentElement.querySelector('[data-quantity-input]');
        const next = Number(input.value) + Number(button.dataset.quantityStep);

        if (next < 0) return;

        input.value = next;
        this.submit();
      });

      this.addEventListener('change', (event) => {
        if (!event.target.matches('[data-quantity-input]')) return;

        this.submit();
      });
    }

    /* The lines are dimmed while the request is in flight rather than left
       looking untouched.

       Only the buttons are disabled: a disabled input is left out of the POST
       entirely, which would drop that line's `updates[key]` and silently
       discard the change. The inputs go read-only instead, so they still
       submit. */
    submit() {
      this.querySelectorAll('[data-quantity-step]').forEach((button) => {
        button.disabled = true;
      });

      this.querySelectorAll('[data-quantity-input]').forEach((input) => {
        input.readOnly = true;
      });

      /* `submit()` rather than `requestSubmit()`: the latter runs the form's
         constraint validation, which the required terms checkbox would fail.
         A quantity change is not a checkout. */
      this.classList.add('is-updating');
      this.form.submit();
    }
  }

  if (!customElements.get('cart-lines')) {
    customElements.define('cart-lines', CartLines);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  /* Progressive enhancement only: the form submits on its own without this.
     Changing a control resubmits it, so a customer doesn't have to find the
     Apply button after every tick. */
  class CollectionToolbar extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');

      if (!this.form) return;

      this.form.addEventListener('change', (event) => {
        /* Price inputs are typed, not picked - resubmitting on every keystroke
           would fight the customer. They commit with Apply or Enter. */
        if (event.target.type === 'number') return;

        this.form.requestSubmit();
      });
    }
  }

  if (!customElements.get('collection-toolbar')) {
    customElements.define('collection-toolbar', CollectionToolbar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.faq__trigger').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const item = trigger.closest('.faq__item');
        const isOpen = item.getAttribute('data-open') === 'true';

        item.setAttribute('data-open', String(!isOpen));
        trigger.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /* Hide the header while scrolling down, reveal it as soon as the visitor
     scrolls back up. */
  (function () {
    const wrapper = document.querySelector('.shopify-section-group-header-group');
    const header = document.querySelector('.header');
    if (!wrapper || !header) return;

    /* Momentum scrolling reports jittery one-pixel deltas; ignore them so the
       header does not flicker. */
    const DELTA_THRESHOLD = 6;

    let lastY = window.scrollY;
    let raf = null;

    function update() {
      raf = null;

      const y = window.scrollY;
      const delta = y - lastY;

      /* Keep lastY where it is so small movements accumulate into a real one. */
      if (Math.abs(delta) < DELTA_THRESHOLD) return;

      const menuOpen = header.querySelector('.header__mobile-nav[open]') !== null;
      const nearTop = y <= header.offsetHeight;

      wrapper.classList.toggle('is-hidden', delta > 0 && !nearTop && !menuOpen);

      lastY = y;
    }

    window.addEventListener(
      'scroll',
      () => {
        if (!raf) raf = window.requestAnimationFrame(update);
      },
      { passive: true }
    );
  })();

  document.querySelectorAll('[data-cart-drawer-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      document.dispatchEvent(new CustomEvent('cart:open'));
    });
  });

  document.querySelectorAll('.header__cta form').forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();

      const button = event.submitter || form.querySelector('.header__cta-button');
      document.dispatchEvent(
        new CustomEvent('cart:add', { detail: window.cartAddDetail(new FormData(form), button) })
      );
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klidna-prochazka-features-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFeatureCarousel(root) {
      const viewport = root.querySelector('[data-kp-fc-viewport]');
      const slides = Array.from(root.querySelectorAll('[data-kp-fc-slide]'));
      const tabs = Array.from(root.querySelectorAll('[data-kp-fc-tab]'));
      const dots = Array.from(root.querySelectorAll('[data-kp-fc-dot]'));
      const prevButton = root.querySelector('[data-kp-fc-prev]');
      const nextButton = root.querySelector('[data-kp-fc-next]');
      const counter = root.querySelector('[data-kp-fc-current]');
      const tabStrip = root.querySelector('[data-kp-fc-tabs]');
      const autoplayMs = Number(root.dataset.autoplay) || 0;

      if (!viewport || slides.length === 0) return;

      let activeIndex = 0;
      let userInteracted = false;
      let scrollRaf = null;
      let autoplayTimer = null;
      /* Scrolls we start ourselves must not count as user interaction, or
         autoplay would stop itself on its very first advance. */
      let ignoreScrollUntil = 0;

      function setActive(index) {
        activeIndex = index;
        tabs.forEach(function (tab) {
          tab.setAttribute('aria-selected', Number(tab.dataset.index) === index ? 'true' : 'false');
        });
        dots.forEach(function (dot) {
          dot.setAttribute('aria-selected', Number(dot.dataset.index) === index ? 'true' : 'false');
        });
        if (counter) counter.textContent = String(index + 1);
        centerTab(index);
      }

      /* Keep the active chip visible in the mobile tab strip. */
      function centerTab(index) {
        const tab = tabs[index];
        if (!tabStrip || !tab) return;
        if (tabStrip.scrollWidth <= tabStrip.clientWidth) return;
        tabStrip.scrollTo({
          left: tab.offsetLeft - tabStrip.offsetLeft - tabStrip.clientWidth / 2 + tab.clientWidth / 2,
          behavior: 'smooth'
        });
      }

      function scrollToIndex(index) {
        const slide = slides[index];
        if (!slide) return;
        ignoreScrollUntil = performance.now() + 900;
        const offset = (viewport.clientWidth - slide.offsetWidth) / 2;
        const left = Math.max(0, slide.offsetLeft - viewport.offsetLeft - offset);
        viewport.scrollTo({ left: left, behavior: 'smooth' });
      }

      function goToIndex(index, fromUser) {
        const bounded = ((index % slides.length) + slides.length) % slides.length;
        if (fromUser) userInteracted = true;
        setActive(bounded);
        scrollToIndex(bounded);
      }

      tabs.concat(dots).forEach(function (button) {
        button.addEventListener('click', function () {
          goToIndex(Number(button.dataset.index), true);
        });
      });

      if (prevButton) {
        prevButton.addEventListener('click', function () {
          goToIndex(activeIndex - 1, true);
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          goToIndex(activeIndex + 1, true);
        });
      }

      viewport.addEventListener(
        'scroll',
        function () {
          /* Our own smooth scroll passes over intermediate slides; recomputing
             the active index mid-flight makes the counter and dots jump. */
          if (performance.now() <= ignoreScrollUntil) return;
          userInteracted = true;
          if (scrollRaf) return;
          scrollRaf = window.requestAnimationFrame(function () {
            scrollRaf = null;
            const center = viewport.scrollLeft + viewport.clientWidth / 2;
            let closest = activeIndex;
            let closestDistance = Infinity;

            slides.forEach(function (slide, index) {
              const slideCenter = slide.offsetLeft - viewport.offsetLeft + slide.clientWidth / 2;
              const distance = Math.abs(slideCenter - center);
              if (distance < closestDistance) {
                closestDistance = distance;
                closest = index;
              }
            });

            if (closest !== activeIndex) setActive(closest);
          });
        },
        { passive: true }
      );

      if (autoplayMs && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        autoplayTimer = window.setInterval(function () {
          if (userInteracted) {
            window.clearInterval(autoplayTimer);
            return;
          }
          goToIndex(activeIndex + 1, false);
        }, autoplayMs);
      }

      setActive(0);
    }

    document.querySelectorAll('[data-kp-fc]').forEach(initFeatureCarousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klidna-prochazka-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const ROTATE_MS = 2000;
    const FADE_MS = 300;

    function initRotator(el) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      let phrases;
      try {
        phrases = JSON.parse(el.dataset.phrases);
      } catch (error) {
        return;
      }

      if (!Array.isArray(phrases) || phrases.length < 2) return;

      let index = 0;

      setInterval(function () {
        /* Skip the tick in a backgrounded tab so we don't churn while unseen. */
        if (document.hidden) return;

        el.classList.add('is-fading');

        setTimeout(function () {
          index = (index + 1) % phrases.length;
          el.textContent = phrases[index];
          el.classList.remove('is-fading');
        }, FADE_MS);
      }, ROTATE_MS);
    }

    document.querySelectorAll('[data-kp-hero-rotator]').forEach(initRotator);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klidna-prochazka-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initProductHero(root) {
      const viewport = root.querySelector('[data-kp-product-viewport]');
      const slides = Array.from(root.querySelectorAll('[data-kp-product-slide]'));
      const thumbs = Array.from(root.querySelectorAll('[data-kp-product-thumb]'));
      const prevButton = root.querySelector('[data-kp-product-prev]');
      const nextButton = root.querySelector('[data-kp-product-next]');

      if (!viewport || slides.length === 0) return;

      let activeIndex = 0;
      let scrollRaf = null;
      /* Our own smooth scroll passes over intermediate slides; recomputing the
         active index mid-flight makes the thumbnails flicker. */
      let ignoreScrollUntil = 0;

      function setActive(index) {
        activeIndex = index;
        thumbs.forEach(function (thumb) {
          thumb.setAttribute('aria-selected', Number(thumb.dataset.index) === index ? 'true' : 'false');
        });
      }

      function scrollToIndex(index) {
        const slide = slides[index];
        if (!slide) return;
        ignoreScrollUntil = performance.now() + 900;
        viewport.scrollTo({ left: slide.offsetLeft - viewport.offsetLeft, behavior: 'smooth' });
      }

      function goToIndex(index) {
        const bounded = ((index % slides.length) + slides.length) % slides.length;
        setActive(bounded);
        scrollToIndex(bounded);
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          goToIndex(Number(thumb.dataset.index));
        });
      });

      if (prevButton) {
        prevButton.addEventListener('click', function () {
          goToIndex(activeIndex - 1);
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          goToIndex(activeIndex + 1);
        });
      }

      viewport.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goToIndex(activeIndex - 1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          goToIndex(activeIndex + 1);
        }
      });

      viewport.addEventListener(
        'scroll',
        function () {
          if (performance.now() <= ignoreScrollUntil) return;
          if (scrollRaf) return;
          scrollRaf = window.requestAnimationFrame(function () {
            scrollRaf = null;
            let closest = activeIndex;
            let closestDistance = Infinity;

            slides.forEach(function (slide, index) {
              const distance = Math.abs(slide.offsetLeft - viewport.offsetLeft - viewport.scrollLeft);
              if (distance < closestDistance) {
                closestDistance = distance;
                closest = index;
              }
            });

            if (closest !== activeIndex) setActive(closest);
          });
        },
        { passive: true }
      );

      /* Hand the add-to-cart over to the cart drawer instead of a full page POST. */
      const form = root.querySelector('form[action*="/cart/add"]');
      if (form) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          const button = event.submitter || form.querySelector('.kp-product__button');
          document.dispatchEvent(
            new CustomEvent('cart:add', { detail: window.cartAddDetail(new FormData(form), button) })
          );
        });
      }

      initPromo(root);

      setActive(0);
    }

    /* Weekly deal cycle: the offer runs until Sunday 23:59:59 and the bar hides
       for two hours after it ends before the next week's cycle starts. */
    const HIDE_AFTER_END_MS = 2 * 60 * 60 * 1000;

    function endOfCurrentWeek(from) {
      const date = new Date(from);
      date.setDate(date.getDate() + ((7 - date.getDay()) % 7));
      date.setHours(23, 59, 59, 999);
      return date;
    }

    function computeCycle(now) {
      const currentEnd = endOfCurrentWeek(now);
      const diff = currentEnd.getTime() - now.getTime();
      if (diff > 0) return { visible: true, target: currentEnd };

      if (now.getTime() - currentEnd.getTime() < HIDE_AFTER_END_MS) {
        return { visible: false, target: currentEnd };
      }

      const nextEnd = new Date(currentEnd);
      nextEnd.setDate(nextEnd.getDate() + 7);
      return { visible: true, target: nextEnd };
    }

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function initPromo(root) {
      const promo = root.querySelector('[data-kp-promo]');
      if (!promo) return;

      const copyButton = promo.querySelector('[data-kp-promo-copy]');
      const codeValue = promo.querySelector('[data-kp-promo-value]');
      const daysPill = promo.querySelector('[data-kp-promo-days]');
      const daysColon = promo.querySelector('[data-kp-promo-colon-days]');
      const out = {
        days: promo.querySelector('[data-kp-promo-value-days]'),
        hours: promo.querySelector('[data-kp-promo-value-hours]'),
        minutes: promo.querySelector('[data-kp-promo-value-minutes]'),
        seconds: promo.querySelector('[data-kp-promo-value-seconds]')
      };

      if (copyButton && codeValue && navigator.clipboard) {
        copyButton.addEventListener('click', function () {
          navigator.clipboard.writeText(codeValue.textContent.trim()).then(function () {
            copyButton.dataset.copied = 'true';
            window.setTimeout(function () {
              delete copyButton.dataset.copied;
            }, 1800);
          });
        });
      }

      function tick() {
        const now = new Date();
        const cycle = computeCycle(now);

        promo.hidden = !cycle.visible;
        if (!cycle.visible) return;

        const total = Math.max(0, Math.floor((cycle.target.getTime() - now.getTime()) / 1000));
        const days = Math.floor(total / 86400);

        if (daysPill) daysPill.hidden = days === 0;
        if (daysColon) daysColon.hidden = days === 0;

        if (out.days) out.days.textContent = pad(days);
        if (out.hours) out.hours.textContent = pad(Math.floor((total % 86400) / 3600));
        if (out.minutes) out.minutes.textContent = pad(Math.floor((total % 3600) / 60));
        if (out.seconds) out.seconds.textContent = pad(total % 60);
      }

      tick();
      window.setInterval(tick, 1000);
    }

    document.querySelectorAll('[data-kp-product]').forEach(initProductHero);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klidna-prochazka-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initReviewsCarousel(root) {
      const viewport = root.querySelector('[data-kp-reviews-viewport]');
      const slides = Array.from(root.querySelectorAll('[data-kp-reviews-slide]'));
      const dots = Array.from(root.querySelectorAll('[data-kp-reviews-dot]'));
      const prevButton = root.querySelector('[data-kp-reviews-prev]');
      const nextButton = root.querySelector('[data-kp-reviews-next]');
      const realCount = Number(root.dataset.realCount) || dots.length;

      if (!viewport || slides.length === 0 || realCount === 0) return;

      let activeIndex = realCount;
      let scrollRaf = null;
      let settleTimer = null;

      function normalize(index) {
        return ((index % realCount) + realCount) % realCount;
      }

      function scrollToIndex(index, behavior) {
        const slide = slides[index];
        if (!slide) return;
        viewport.scrollTo({ left: slide.offsetLeft, behavior: behavior || 'smooth' });
      }

      function setActive(index) {
        activeIndex = index;
        const dotIndex = normalize(activeIndex);
        dots.forEach(function (dot) {
          dot.setAttribute('aria-selected', Number(dot.dataset.index) === dotIndex ? 'true' : 'false');
        });
      }

      function goToIndex(index) {
        setActive(index);
        scrollToIndex(index);
      }

      /* Once a scroll settles outside the middle copy, jump back to the matching
         slide in the middle one. That is what makes paging past either end -
         including backwards from the first review - never run out of slides. */
      function recenterIfNeeded() {
        let shift = 0;
        if (activeIndex < realCount) {
          shift = realCount;
        } else if (activeIndex >= realCount * 2) {
          shift = -realCount;
        }
        if (shift === 0) return;

        const newIndex = activeIndex + shift;
        scrollToIndex(newIndex, 'auto');
        setActive(newIndex);
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          goToIndex(realCount + Number(dot.dataset.index));
        });
      });

      if (prevButton) {
        prevButton.addEventListener('click', function () {
          goToIndex(activeIndex - 1);
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          goToIndex(activeIndex + 1);
        });
      }

      viewport.addEventListener(
        'scroll',
        function () {
          if (!scrollRaf) {
            scrollRaf = window.requestAnimationFrame(function () {
              scrollRaf = null;
              let closestIndex = activeIndex;
              let closestDistance = Infinity;

              slides.forEach(function (slide, index) {
                const distance = Math.abs(slide.offsetLeft - viewport.scrollLeft);
                if (distance < closestDistance) {
                  closestDistance = distance;
                  closestIndex = index;
                }
              });

              setActive(closestIndex);
            });
          }

          if (settleTimer) {
            window.clearTimeout(settleTimer);
          }
          settleTimer = window.setTimeout(function () {
            settleTimer = null;
            recenterIfNeeded();
          }, 150);
        },
        { passive: true }
      );

      let isPointerDragging = false;
      let dragStartX = 0;
      let dragStartScrollLeft = 0;
      let dragMoved = false;
      let suppressNextClick = false;

      viewport.addEventListener('pointerdown', function (event) {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        isPointerDragging = true;
        dragMoved = false;
        dragStartX = event.clientX;
        dragStartScrollLeft = viewport.scrollLeft;
        viewport.classList.add('is-dragging');
      });

      viewport.addEventListener('pointermove', function (event) {
        if (!isPointerDragging) return;
        const delta = event.clientX - dragStartX;
        if (Math.abs(delta) > 3) {
          dragMoved = true;
        }
        if (dragMoved) {
          event.preventDefault();
          viewport.scrollLeft = dragStartScrollLeft - delta;
        }
      });

      function endPointerDrag() {
        if (!isPointerDragging) return;
        isPointerDragging = false;

        if (!dragMoved) {
          viewport.classList.remove('is-dragging');
          return;
        }

        suppressNextClick = true;
        scrollToIndex(activeIndex, 'smooth');

        if ('onscrollend' in window) {
          viewport.addEventListener('scrollend', function handler() {
            viewport.removeEventListener('scrollend', handler);
            viewport.classList.remove('is-dragging');
          });
        } else {
          window.setTimeout(function () {
            viewport.classList.remove('is-dragging');
          }, 400);
        }
      }

      viewport.addEventListener('pointerup', endPointerDrag);
      viewport.addEventListener('pointerleave', endPointerDrag);
      viewport.addEventListener('pointercancel', endPointerDrag);

      viewport.addEventListener(
        'click',
        function (event) {
          if (suppressNextClick) {
            event.preventDefault();
            event.stopPropagation();
            suppressNextClick = false;
          }
        },
        true
      );

      setActive(realCount);
      scrollToIndex(realCount, 'auto');
    }

    document.querySelectorAll('[data-kp-reviews]').forEach(initReviewsCarousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klidna-prochazka-situations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSituations(root) {
      const slots = Array.from(root.querySelectorAll('[data-kp-situations-slot]'));
      const cards = slots.map(function (slot) {
        return slot.querySelector('[data-kp-situations-card]');
      });

      if (cards.length === 0) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      let ticking = false;

      /* Shrink a pinned card as the next one slides over it, so the stack reads
         as depth rather than as cards simply overlapping. */
      function update() {
        ticking = false;

        for (let i = 0; i < cards.length; i++) {
          const card = cards[i];
          if (!card) continue;

          const next = slots[i + 1];
          if (!next) {
            card.style.transform = '';
            continue;
          }

          const nextRect = next.getBoundingClientRect();
          const cardRect = card.getBoundingClientRect();
          const travel = Math.max(1, cardRect.height);
          const distance = cardRect.top + cardRect.height - nextRect.top;
          let progress = distance / travel;
          if (progress < 0) progress = 0;
          if (progress > 1) progress = 1;

          card.style.transform = 'scale(' + (1 - progress * 0.05) + ')';
        }
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      }

      update();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
    }

    document.querySelectorAll('[data-kp-situations]').forEach(initSituations);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  class PasswordGate extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.input = this.querySelector('input[type="password"]');

      this.querySelector('[data-gate-open]')?.addEventListener('click', (event) => {
        event.preventDefault();
        this.open();
      });

      this.querySelector('[data-gate-close]')?.addEventListener('click', () => {
        this.dialog?.close();
      });

      // Clicking the backdrop lands on the dialog element itself.
      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });

      // A wrong password reloads the page, so reopen to show the error.
      if (this.querySelector('.gate__errors')) this.open();
    }

    open() {
      if (!this.dialog?.showModal) return;
      this.dialog.showModal();
      this.input?.focus();
    }
  }

  if (!customElements.get('password-gate')) {
    customElements.define('password-gate', PasswordGate);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["personal-offer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('personal-offer')) {
    customElements.define(
      'personal-offer',
      class PersonalOffer extends HTMLElement {
        connectedCallback() {
          this.code = this.dataset.code || '';
          this.deadline = Number(this.dataset.endsAt || 0) * 1000;
          this.units = {};
          this.querySelectorAll('[data-offer-unit]').forEach((element) => {
            this.units[element.dataset.offerUnit] = element;
          });

          if (this.deadline > 0) {
            this.tick();
            if (this.dataset.state !== 'expired') this.timer = setInterval(() => this.tick(), 1000);
          }
          if (this.dataset.state !== 'expired') this.applyCode();

          const copyButton = this.querySelector('[data-offer-copy]');
          if (copyButton) {
            copyButton.addEventListener('click', () => this.copyCode(copyButton));
          }
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        tick() {
          const left = Math.max(0, this.deadline - Date.now());
          const seconds = Math.floor(left / 1000);
          const values = {
            days: Math.floor(seconds / 86400),
            hours: Math.floor((seconds % 86400) / 3600),
            minutes: Math.floor((seconds % 3600) / 60),
            seconds: seconds % 60,
          };

          Object.entries(values).forEach(([unit, value]) => {
            if (this.units[unit]) this.units[unit].textContent = String(value).padStart(2, '0');
          });

          if (left === 0) {
            this.dataset.state = 'expired';
            clearInterval(this.timer);
          }
        }

        // Puts the code on the visitor's cart, so the checkout takes it off
        // even if they never type it in. Following Shopify's discount link
        // straight from the button would lose the #tracker anchor, so it is
        // requested here in the background instead.
        applyCode() {
          if (this.dataset.applyCode !== 'true' || !this.code) return;
          if (window.Shopify && window.Shopify.designMode) return;

          fetch(`/discount/${encodeURIComponent(this.code)}?redirect=/cart.js`, {
            credentials: 'same-origin',
          }).catch(() => {});
        }

        async copyCode(button) {
          const valueElement = button.querySelector('[data-offer-code-value]');
          const status = this.querySelector('[data-offer-copy-status]');

          try {
            await navigator.clipboard.writeText(this.code);
          } catch (error) {
            // Without clipboard access, select the code so it can be copied by hand.
            if (valueElement) {
              const range = document.createRange();
              range.selectNodeContents(valueElement);
              const selection = window.getSelection();
              selection.removeAllRanges();
              selection.addRange(range);
            }
            return;
          }

          button.dataset.copied = 'true';
          if (status) {
            this.hint = this.hint || status.textContent;
            status.textContent = status.dataset.copiedText;
          }

          clearTimeout(this.copyTimeout);
          this.copyTimeout = setTimeout(() => {
            button.dataset.copied = 'false';
            if (status) status.textContent = this.hint;
          }, 2500);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  /* Variant switching re-renders only the price, through the Section Rendering
     API, so money and translations stay formatted server side. It mirrors how
     the cart drawer refreshes itself.

     The buy buttons are updated in place rather than replaced, so the form
     keeps its listeners and focus. */
  class ProductInfo extends HTMLElement {
    connectedCallback() {
      /* connectedCallback runs again whenever the element is moved. */
      if (this.bound) return;
      this.bound = true;

      this.sectionId = this.dataset.sectionId;
      this.productUrl = this.dataset.productUrl;
      this.requestToken = 0;

      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-variant-option]')) this.onOptionChange();
      });
    }

    get variants() {
      const script = this.querySelector('[data-product-variants]');
      if (!script) return [];

      try {
        return JSON.parse(script.textContent);
      } catch (error) {
        console.error('Could not read the product variants', error);
        return [];
      }
    }

    get selectedOptions() {
      const values = [];

      this.querySelectorAll('[data-variant-option]').forEach((input) => {
        const position = Number(input.dataset.optionPosition) - 1;
        if (input.tagName === 'SELECT' || input.checked) values[position] = input.value;
      });

      return values;
    }

    onOptionChange() {
      const selected = this.selectedOptions;
      const variant = this.variants.find((candidate) =>
        selected.every((value, index) => candidate.options[index] === value)
      );

      this.updateSelectedLabels();
      this.updateBuyButtons(variant);

      if (!variant) return;

      if (variant.featured_media) {
        const gallery = this.querySelector('[data-product-gallery]');
        if (gallery && gallery.productGallery) gallery.productGallery.goToMediaId(variant.featured_media.id);
      }

      window.history.replaceState({}, '', `${this.productUrl}?variant=${variant.id}`);
      this.renderPrice(variant.id);
    }

    updateSelectedLabels() {
      this.querySelectorAll('[data-variant-option]').forEach((input) => {
        if (input.tagName !== 'SELECT' && !input.checked) return;

        const label = input.closest('.variant-picker__option');
        const output = label && label.querySelector('[data-variant-selected-value]');
        if (output) output.textContent = input.value;
      });
    }

    updateBuyButtons(variant) {
      const button = this.querySelector('[data-add-to-cart]');
      const input = this.querySelector('[data-variant-id]');
      if (!button) return;

      if (!variant) {
        button.disabled = true;
        button.textContent = this.dataset.unavailableText;
        if (input) input.disabled = true;
        return;
      }

      if (input) {
        input.value = variant.id;
        input.disabled = !variant.available;
      }

      button.disabled = !variant.available;
      button.textContent = variant.available ? this.dataset.addToCartText : this.dataset.soldOutText;
    }

    async renderPrice(variantId) {
      const token = ++this.requestToken;
      const price = this.querySelector('[data-product-price]');
      if (!price) return;

      price.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(`${this.productUrl}?variant=${variantId}&section_id=${this.sectionId}`);
        if (!response.ok) throw new Error(`Section render failed with ${response.status}`);

        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');

        /* A newer selection may have landed while this request was in flight. */
        if (token !== this.requestToken) return;

        const source = parsed.querySelector('[data-product-price]');
        if (source) price.innerHTML = source.innerHTML;
      } catch (error) {
        console.error(error);
      } finally {
        if (token === this.requestToken) price.removeAttribute('aria-busy');
      }
    }
  }

  if (!customElements.get('product-info')) {
    customElements.define('product-info', ProductInfo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const button = document.querySelector('[data-promo-code-button]');
    if (!button) return;

    const valueEl = button.querySelector('[data-promo-code-value]');
    let resetTimeout;

    button.addEventListener('click', async () => {
      const code = valueEl ? valueEl.textContent.trim() : '';

      try {
        await navigator.clipboard.writeText(code);
      } catch (error) {
        return;
      }

      button.setAttribute('data-copied', 'true');

      clearTimeout(resetTimeout);
      resetTimeout = setTimeout(() => {
        button.setAttribute('data-copied', 'false');
      }, 2000);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-product-bar"] && !Shopify.designMode) return;
  try {
    
  class StickyProductBar extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;

      this.showAfter = Number(this.dataset.showAfter) || 0;
      this.scrollRaf = null;

      this.onScroll = () => {
        if (this.scrollRaf) return;
        this.scrollRaf = window.requestAnimationFrame(() => {
          this.scrollRaf = null;
          this.classList.toggle('is-visible', window.scrollY > this.showAfter);
        });
      };

      window.addEventListener('scroll', this.onScroll, { passive: true });

      /* Reloading mid-page must not leave the bar hidden. */
      this.classList.toggle('is-visible', window.scrollY > this.showAfter);

      this.bindForm();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      this.bound = false;
    }

    bindForm() {
      const form = this.querySelector('form[action*="/cart/add"]');
      if (!form) return;

      /* Hand the add over to the cart drawer instead of a full page POST. */
      form.addEventListener('submit', (event) => {
        event.preventDefault();

        const formData = new FormData(form);
        if (!formData.get('id')) return;

        const button = event.submitter || form.querySelector('.sticky-bar__button');
        document.dispatchEvent(new CustomEvent('cart:add', { detail: window.cartAddDetail(formData, button) }));
      });
    }
  }

  if (!customElements.get('sticky-product-bar')) {
    customElements.define('sticky-product-bar', StickyProductBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription-product"]) return;
  try {
    
  /* Picking a period swaps the variant the add-to-cart form submits and keeps
     the URL on that variant, so a shared link opens the same period. */
  class SubscriptionProduct extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;

      this.addEventListener('change', (event) => {
        if (!event.target.matches('[data-period-input]')) return;

        const input = this.querySelector('[data-variant-id]');
        if (input) input.value = event.target.value;

        window.history.replaceState({}, '', `${this.dataset.productUrl}?variant=${event.target.value}`);
      });
    }
  }

  if (!customElements.get('subscription-product')) {
    customElements.define('subscription-product', SubscriptionProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initVideoCarousel(root) {
      const viewport = root.querySelector('[data-video-carousel-viewport]');
      const slides = Array.from(root.querySelectorAll('[data-video-carousel-slide]'));
      const dots = Array.from(root.querySelectorAll('[data-video-carousel-dot]'));
      const prevButton = root.querySelector('[data-video-carousel-prev]');
      const nextButton = root.querySelector('[data-video-carousel-next]');
      const realCount = Number(root.dataset.realCount) || dots.length;

      if (!viewport || slides.length === 0 || realCount === 0) return;

      let activeIndex = realCount;
      let scrollRaf = null;
      let settleTimer = null;
      let isSectionVisible = false;
      let preferUnmuted = false;

      function normalize(index) {
        return ((index % realCount) + realCount) % realCount;
      }

      function getVideo(slide) {
        return slide.querySelector('video');
      }

      function getMuteButton(slide) {
        return slide.querySelector('[data-video-carousel-mute]');
      }

      function updateMuteButton(muteButton, muted) {
        if (!muteButton) return;
        muteButton.dataset.state = muted ? 'muted' : 'unmuted';
        muteButton.setAttribute('aria-pressed', muted ? 'false' : 'true');
        muteButton.setAttribute(
          'aria-label',
          muted ? muteButton.dataset.labelUnmute : muteButton.dataset.labelMute
        );
      }

      function scrollToIndex(index, behavior) {
        const slide = slides[index];
        if (!slide) return;
        const target =
          slide.offsetLeft - (viewport.clientWidth - slide.offsetWidth) / 2;
        viewport.scrollTo({ left: target, behavior: behavior || 'smooth' });
      }

      function pauseAllExcept(index) {
        slides.forEach(function (slide, slideIndex) {
          if (slideIndex === index) return;
          if (!slide.classList.contains('is-active') && !slide.classList.contains('is-playing')) return;
          slide.classList.remove('is-active', 'is-playing');
          const video = getVideo(slide);
          if (video) {
            video.pause();
            video.muted = true;
            try {
              video.currentTime = 0;
            } catch (error) {}
            video.load();
          }
          updateMuteButton(getMuteButton(slide), true);
        });
      }

      function setActive(index, options) {
        options = options || {};
        if (index === activeIndex && !options.force) return;

        activeIndex = index;
        pauseAllExcept(activeIndex);

        const slide = slides[activeIndex];
        if (slide) {
          slide.classList.add('is-active');
          const video = getVideo(slide);
          if (video) {
            video.muted = !preferUnmuted;
          }
          updateMuteButton(getMuteButton(slide), video ? video.muted : true);
        }

        const dotIndex = normalize(activeIndex);
        dots.forEach(function (dot) {
          dot.setAttribute(
            'aria-selected',
            Number(dot.dataset.index) === dotIndex ? 'true' : 'false'
          );
        });

        if (options.play && isSectionVisible) {
          playActiveVideo();
        }
      }

      function playActiveVideo() {
        if (!isSectionVisible) return;
        const slide = slides[activeIndex];
        if (!slide) return;
        const video = getVideo(slide);
        if (!video) return;
        if (!video.paused) return;

        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      }

      function pauseActiveForVisibility() {
        const slide = slides[activeIndex];
        if (!slide) return;
        const video = getVideo(slide);
        if (video) {
          video.pause();
          video.muted = true;
        }
        updateMuteButton(getMuteButton(slide), true);
      }

      function resumeActiveForVisibility() {
        const slide = slides[activeIndex];
        if (!slide) return;
        const video = getVideo(slide);
        if (video) {
          video.muted = !preferUnmuted;
        }
        updateMuteButton(getMuteButton(slide), video ? video.muted : true);
        playActiveVideo();
      }

      function recenterIfNeeded() {
        let shift = 0;
        if (activeIndex < realCount) {
          shift = realCount;
        } else if (activeIndex >= realCount * 2) {
          shift = -realCount;
        }
        if (shift === 0) {
          playActiveVideo();
          return;
        }

        const newIndex = activeIndex + shift;
        scrollToIndex(newIndex, 'auto');
        setActive(newIndex, { force: true, play: true });
      }

      slides.forEach(function (slide) {
        const video = getVideo(slide);
        const playButton = slide.querySelector('[data-video-carousel-play]');
        const muteButton = slide.querySelector('[data-video-carousel-mute]');

        if (video) {
          video.addEventListener('playing', function () {
            slide.classList.add('is-playing');
          });
          video.addEventListener('pause', function () {
            slide.classList.remove('is-playing');
          });
        }

        if (playButton) {
          playButton.addEventListener('click', function () {
            const index = Number(slide.dataset.index);
            if (index !== activeIndex) {
              scrollToIndex(index);
            } else {
              playActiveVideo();
            }
          });
        }

        if (muteButton && video) {
          muteButton.addEventListener('click', function () {
            video.muted = !video.muted;
            preferUnmuted = !video.muted;
            updateMuteButton(muteButton, video.muted);
          });
        }

        slide.addEventListener('click', function (event) {
          if (event.target.closest('button')) return;
          const index = Number(slide.dataset.index);
          if (index !== activeIndex) {
            scrollToIndex(index);
          }
        });
      });

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          scrollToIndex(realCount + Number(dot.dataset.index));
        });
      });

      if (prevButton) {
        prevButton.addEventListener('click', function () {
          const target = realCount + normalize(normalize(activeIndex) - 1);
          scrollToIndex(target);
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          const target = realCount + normalize(normalize(activeIndex) + 1);
          scrollToIndex(target);
        });
      }

      viewport.addEventListener(
        'scroll',
        function () {
          if (scrollRaf) return;
          scrollRaf = window.requestAnimationFrame(function () {
            scrollRaf = null;
            const viewportCenter = viewport.scrollLeft + viewport.clientWidth / 2;
            let closestIndex = activeIndex;
            let closestDistance = Infinity;

            slides.forEach(function (slide, index) {
              const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
              const distance = Math.abs(slideCenter - viewportCenter);
              if (distance < closestDistance) {
                closestDistance = distance;
                closestIndex = index;
              }
            });

            setActive(closestIndex);
          });

          if (settleTimer) {
            window.clearTimeout(settleTimer);
          }
          settleTimer = window.setTimeout(function () {
            settleTimer = null;
            recenterIfNeeded();
          }, 150);
        },
        { passive: true }
      );

      const sectionObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && !isSectionVisible) {
              isSectionVisible = true;
              resumeActiveForVisibility();
            } else if (!entry.isIntersecting && isSectionVisible) {
              isSectionVisible = false;
              pauseActiveForVisibility();
            }
          });
        },
        { threshold: 0.4 }
      );
      sectionObserver.observe(root);

      let isPointerDragging = false;
      let dragStartX = 0;
      let dragStartScrollLeft = 0;
      let dragMoved = false;
      let suppressNextClick = false;

      viewport.addEventListener('pointerdown', function (event) {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        isPointerDragging = true;
        dragMoved = false;
        dragStartX = event.clientX;
        dragStartScrollLeft = viewport.scrollLeft;
        viewport.classList.add('is-dragging');
      });

      viewport.addEventListener('pointermove', function (event) {
        if (!isPointerDragging) return;
        const delta = event.clientX - dragStartX;
        if (Math.abs(delta) > 3) {
          dragMoved = true;
        }
        if (dragMoved) {
          event.preventDefault();
          viewport.scrollLeft = dragStartScrollLeft - delta;
        }
      });

      function endPointerDrag() {
        if (!isPointerDragging) return;
        isPointerDragging = false;

        if (!dragMoved) {
          viewport.classList.remove('is-dragging');
          return;
        }

        suppressNextClick = true;
        scrollToIndex(activeIndex, 'smooth');

        if ('onscrollend' in window) {
          viewport.addEventListener('scrollend', function handler() {
            viewport.removeEventListener('scrollend', handler);
            viewport.classList.remove('is-dragging');
          });
        } else {
          window.setTimeout(function () {
            viewport.classList.remove('is-dragging');
          }, 400);
        }
      }

      viewport.addEventListener('pointerup', endPointerDrag);
      viewport.addEventListener('pointerleave', endPointerDrag);
      viewport.addEventListener('pointercancel', endPointerDrag);

      viewport.addEventListener(
        'click',
        function (event) {
          if (suppressNextClick) {
            event.preventDefault();
            event.stopPropagation();
            suppressNextClick = false;
          }
        },
        true
      );

      setActive(realCount, { force: true, play: false });
      scrollToIndex(realCount, 'auto');
    }

    document.querySelectorAll('[data-video-carousel]').forEach(initVideoCarousel);
  })();

  } catch(e) { console.error(e); }
})();
})();
